<app-content-header 
    [historyBack]="false" 
    (backEvent)="onBack()" 
    [headline]="'tariff_choose_headline' | i18next">
</app-content-header>

<div class="flex-column h-100 d-flex">
    <div class="row mt-5 g-2 justify-content-center">
        <div class="col-12 col-md-5 mb-3 mb-md-0">
            <app-base-price-card 
                name="tariff_fair_flats" 
                [product]="smallestFairFlatTariff.name" 
                [prefixOfPrice]="'fair_flat_price_prefix' | i18next"
                [price]="+smallestFairFlatTariff.listPrice"
                [isSelected]="this.FAIR_FLATS.includes(this.currentPlan)"
                [showSelectButton]="true"
                [buttonText]="'fair_flat_type_select_button' | i18next"
                (selected)="onFairFlatSelected()">
                <div class="h3 mx-auto text-danger fw-bold mb-3 mt-4 ">{{ 'tariff_body_headline' | i18next }}</div>
                <div class="d-flex justify-content-center features">
                    <div class="d-flex flex-column align-items-start">
                        <div [innerHTML]="'fair_flat_benefits' | i18next"></div>
                    </div>
                </div>
            </app-base-price-card>
        </div>
        <div class="col-12 col-md-5">
             <app-base-price-card 
                name="tariff_flat_full" 
                [product]="fullFlatTariff.name"
                [price]="+fullFlatTariff.listPrice"
                timeBilling="per_user_per_month"
                [isSelected]="this.currentPlan === this.FULL_FLAT"
                [buttonText]="'full_flat_select_button' | i18next"
                (selected)="onFullFlatSelected()">
                <div class="h3 mx-auto text-danger fw-bold mb-3 mt-4 ">{{ 'tariff_body_headline' | i18next }}</div>
                <div class="d-flex justify-content-center features">
                    <div class="d-flex flex-column align-items-start">
                        <div [innerHTML]="'full_flat_benefits' | i18next"></div>
                    </div>
                </div>
            </app-base-price-card>
        </div>
    </div>
    <div class="ml-auto mt-auto p-3 small">{{ 'vat_not_included' | i18next }}</div>
</div>